import {getUserDetails, getUsersList, patchUserDetails} from '../actions/user'

const {createSlice} = require('@reduxjs/toolkit')

const initialState = {
  users: [],
  page: 0,
  items_per_page: 10,
  details: {},
  isLoading: false,
  current_page: 0,
  total_pages: 0,
  selectedUserRole: null,
  searchTerm: '',
}

const users = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setSelectedUserRole: (state, action) => {
      state.selectedUserRole = action.payload
      state.current_page = 1 // optional: reset pagination
    },
    resetSelectedUserRole: (state) => {
      state.selectedUserRole = null
      state.current_page = 1
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsersList?.pending, (state, action) => {
      state.isLoading = true
    })

    builder.addCase(getUsersList?.fulfilled, (state, action) => {
      state.isLoading = false
      state.current_page = action?.payload?.current_page
      state.total_pages = action?.payload?.total_pages
      state.users = (action?.payload?.users || []).map((user) => ({
        ...user,
        full_name: user?.full_name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim(),
        user: user?.user || user,
      }))
      state.searchTerm = action?.meta?.arg?.first_name || ''
      // state.customList = action?.payload?.custom_packages;
    })
    builder.addCase(getUsersList?.rejected, (state, action) => {
      state.isLoading = false
    })




    builder.addCase(getUserDetails?.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(getUserDetails?.fulfilled, (state, action) => {
      state.isLoading = false
      state.details = action.payload
    })
    builder.addCase(getUserDetails?.rejected, (state, action) => {
      state.isLoading = false
    })

    builder.addCase(patchUserDetails?.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(patchUserDetails?.fulfilled, (state, action) => {
      state.isLoading = false
    })
    builder.addCase(patchUserDetails?.rejected, (state, action) => {
      state.isLoading = false
    })
  },
})
export const { setSelectedUserRole ,resetSelectedUserRole} = users.actions  
export default users.reducer
